/**
 * @Author: zpc
 * @DateTime: Created in 2021-08-12 14:00:00
 * @Description: 数据自动对接
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {DataButtJointDOI} from "./api/dataButtJointApi";
import DataButtJointService from "./service/dataButtjointService";
import './dataButtJoint.less';
import { createNamespace } from 'src/util/bem';

@Component({name: 'data-buttjoint'})
export default class DataButtJoint extends BasicSearchPage<DataButtJointService, DataButtJointDOI.RowDataI>{
    className=createNamespace('data-buttjoint')

    @override
    renderHead(h) {
        return <div></div>
    }

	@override
	loadService () {
		this.service = new DataButtJointService(this)
	}
}
